<template>
    <div class="container">
        <div class="level">
            <div class="level-left">
                <div class="level-item">
                    <div class="field">
                        <router-link :to="{ name: 'Flights' }" active-class="is-active">
                            <button class="button is-info">
                      <span class="icon">
                    <i class="fas fa-long-arrow-alt-left"></i></span>
                                <span>Back To Flight</span>
                            </button>
                        </router-link>
                    </div>
                </div>
                <div class="level-item">
                    <p class="heading has-text-weight-bold">Flight Planing</p>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <label class="heading">Flight: {{FKey1}}</label>
                </div>
            </div>
        </div>
        <div class="table">
            <table class="table is-fullwidth is-striped">
                <thead>
                <tr>
                    <th>PFB Device</th>
                    <th>Type</th>
                    <th>Generated</th>
                    <th>View</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>TPO</td>
                    <td>AdditionalDoc</td>
                    <td>24-03-2020 12:30:51</td>
                    <td>
                        <font-awesome-icon icon="eye" color="blue" size="lg"
                                           @click="viewAttachment()"></font-awesome-icon>
                    </td>
                </tr>
                <tr>
                    <td>TPO</td>
                    <td>AdditionalDoc</td>
                    <td>24-03-2020 12:30:51</td>
                    <td>
                        <font-awesome-icon icon="eye" color="blue" size="lg"></font-awesome-icon>
                    </td>
                </tr>
                <tr>
                    <td>TPO</td>
                    <td>AdditionalDoc</td>
                    <td>24-03-2020 12:30:51</td>
                    <td>
                        <font-awesome-icon icon="eye" color="blue" size="lg"></font-awesome-icon>
                    </td>
                </tr>
                <tr>
                    <td>TPO</td>
                    <td>AdditionalDoc</td>
                    <td>24-03-2020 12:30:51</td>
                    <td>
                        <font-awesome-icon icon="eye" color="blue" size="lg"></font-awesome-icon>
                    </td>
                </tr>
                <tr>
                    <td>TPO</td>
                    <td>AdditionalDoc</td>
                    <td>24-03-2020 12:30:51</td>
                    <td>
                        <font-awesome-icon icon="eye" color="blue" size="lg"></font-awesome-icon>
                    </td>
                </tr>
                <tr>
                    <td>TPO</td>
                    <td>Notam</td>
                    <td>24-03-2020 12:30:51</td>
                    <td>
                        <font-awesome-icon icon="eye" color="blue" size="lg"></font-awesome-icon>
                    </td>
                </tr>
                <tr>
                    <td>TPO</td>
                    <td>RSChart</td>
                    <td>24-03-2020 12:30:51</td>
                    <td>
                        <font-awesome-icon icon="eye" color="blue" size="lg"></font-awesome-icon>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
    export default {
        name: "FlightPlaning",
        data() {
            return {
                FKey1: this.$route.params.id,
            }
        },
        methods: {
            viewAttachment() {
            }
        }
    }
</script>

<style scoped>

</style>
